import adminApi from '@/api/admin/adminClient';
import { ENDPOINTS } from '@/api/endpoints';
import type { ApiEnvelope } from '@/types/dashboard/auth';
import type { RegisteredUser, RegisterUserPayload } from '@/types/dashboard/vendor';

export const userService = {
  /** Creates a login user. Requires the `user.manage` permission on the backend. */
  async register(payload: RegisterUserPayload): Promise<RegisteredUser> {
    const { data } = await adminApi.post<ApiEnvelope<RegisteredUser>>(
      ENDPOINTS.admin.auth.register,
      payload,
    );
    return data.data;
  },
};